import TabBar from './tab-bar.vue';
import NewPopup from './new-popup.vue';
import NavBar from './nav-bar.vue';
import SearchInput from './search-input.vue';
import NewDialog from './new-dialog.vue';
import SelectPayment from './select-payment.vue';
import SubmitButton from './submit-button.vue';
import PasswordInput from './password-input.vue';
import GetVerificationCode from './get-verification-code.vue';
import NewLoading from './new-loading.vue';

const viewsGlobalcompnent = {
  'tab-bar': TabBar,
  'new-popup': NewPopup,
  'nav-bar': NavBar,
  'search-input': SearchInput,
  'new-dialog': NewDialog,
  'select-payment': SelectPayment,
  'submit-button': SubmitButton,
  'password-input': PasswordInput,
  'get-verification-code': GetVerificationCode,
  'new-loading': NewLoading,
};

export default {
  install(Vue) {
    Object.keys(viewsGlobalcompnent).forEach((key) => {
      Vue.component(key, viewsGlobalcompnent[key]);
    });
  },
};
